import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  const scrollToPurchase = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="pt-32 pb-16 px-4 max-w-4xl mx-auto text-center" data-id="element-95">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} data-id="element-96">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight" data-id="element-97">
          Deja de depender de clases 1 a 1 para vivir como{' '}
          <span className="text-brand-gold" data-id="element-98">profesor de italiano</span>
        </h1>

        <p className="text-lg md:text-xl text-gray-300 mb-10 max-w-3xl mx-auto leading-relaxed" data-id="element-99">
          Descubre cómo profesores están llenando agendas, cobrando más y
          generando ingresos online enseñando italiano… sin trabajar más horas
        </p>

        <div className="bg-brand-card/50 border border-white/10 rounded-2xl p-6 md:p-8 max-w-2xl mx-auto mb-10 text-left" data-id="element-100">
          <ul className="space-y-4 text-gray-200 text-lg" data-id="element-101">
            <li className="flex items-start" data-id="element-102">
              <span className="mr-3" data-id="element-103">❌</span>
              <span data-id="element-104">Horarios limitados = ingresos limitados</span>
            </li>
            <li className="flex items-start" data-id="element-105">
              <span className="mr-3" data-id="element-106">❌</span>
              <span data-id="element-107">Cancelaciones constantes</span>
            </li>
            <li className="flex items-start" data-id="element-108">
              <span className="mr-3" data-id="element-109">❌</span>
              <span data-id="element-110">Cansancio de repetir lo mismo todos los días</span>
            </li>
            <li className="flex items-start font-semibold text-white mt-6 pt-4 border-t border-white/10" data-id="element-111">
              <span className="mr-3" data-id="element-112">✅</span>
              <span className="text-brand-gold" data-id="element-113">
                Empieza a escalar tu conocimiento de italiano en internet
              </span>
            </li>
          </ul>
        </div>

        <button onClick={scrollToPurchase} className="w-full md:w-auto bg-brand-green hover:bg-green-600 text-white font-bold text-xl py-5 px-8 rounded-xl shadow-[0_0_20px_rgba(0,146,70,0.4)] hover:shadow-[0_0_30px_rgba(0,146,70,0.6)] transition-all transform hover:scale-105 mb-12" data-id="element-114">
          👉 Quiero escalar mis ingresos enseñando italiano
        </button>

        <div className="relative max-w-3xl mx-auto" data-id="element-115">
          <div className="absolute inset-0 bg-brand-gold/20 blur-3xl rounded-full" data-id="element-116"></div>
          <img src="https://cdn.magicpatterns.com/uploads/xad2vZLjGL86MmVCy8dS4A/italinao.png" alt="Megapack Italiano Listo" className="relative z-10 w-full h-auto rounded-2xl shadow-2xl cursor-pointer" onClick={scrollToPurchase} data-id="element-117" />
        </div>
      </motion.div>
    </section>;
}